const setupPasswordToggle = (container = document) => {
  const toggles = container.querySelectorAll('.password-toggle');
  
  toggles.forEach(toggle => {
    // Evita di aggiungere più listener se la funzione viene chiamata più volte
    if (toggle.dataset.initialized) return;
    toggle.dataset.initialized = 'true';

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Cerchiamo l'input nel genitore o nel wrapper più vicino
      const wrapper = toggle.closest('.form-input-group') || 
                      toggle.closest('.form-group') || 
                      toggle.parentElement;
      const input = wrapper.querySelector('input');
      
      if (input) {
        if (input.type === 'password') {
          input.type = 'text';
          toggle.classList.remove('fa-eye');
          toggle.classList.add('fa-eye-slash');
        } else {
          input.type = 'password';
          toggle.classList.remove('fa-eye-slash');
          toggle.classList.add('fa-eye');
        }
      }
    });
  });
};

const init = () => {
  setupPasswordToggle();

  // Supporto per contenuti caricati dinamicamente
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Node.ELEMENT_NODE
          setupPasswordToggle(node);
          if (node.classList && node.classList.contains('password-toggle')) {
            setupPasswordToggle(node.parentElement);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
